var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('NavBar'),_c('b-container',[_c('h1',[_vm._v("Terms and conditions")]),_c('hr'),_c('CGV')],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }